import React from 'react';
import { AlertCircle, X } from 'lucide-react';

interface ErrorNotificationProps {
  message: string;
  onClose: () => void;
  className?: string;
}

export const ErrorNotification: React.FC<ErrorNotificationProps> = ({
  message,
  onClose,
  className = ''
}) => {
  return (
    <div className={`flex items-center justify-between p-3 bg-red-50 border border-red-200 rounded-lg text-red-800 ${className}`}>
      <div className="flex items-center space-x-2">
        <AlertCircle className="w-4 h-4 text-red-500 flex-shrink-0" />
        <span className="text-sm">{message}</span>
      </div>
      <button
        onClick={onClose}
        className="p-1 hover:bg-red-100 rounded transition-colors"
        title="Закрыть"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}; 